<style scoped>
    .content{
        position: relative;
    }
</style>
<template>
    <div>
        <Poptip>
            <div>
                <Button size="small" @click="viewInvoices">
                    <slot>查看发票</slot>
                </Button>
            </div>
            <div class="content" slot="content">
                <div class="text-large" v-if="is_empty">未查询到发票信息</div>
                <div v-else>
                    <table class="mis-table">
                        <tr>
                            <th>发票代码</th>
                            <th>发票号码</th>
                            <th>类型</th>
                            <th>金额</th>
                            <th>文件</th>
                        </tr>
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <td>{{invoice.code || '-'}}</td>
                            <td>{{invoice.uid || '-'}}</td>
                            <td>{{getInvoiceType(invoice)}}</td>
                            <td>{{formatPrice(invoice.total_price)}}</td>
                            <td>
                                <InvoicePicture :invoice_id="invoice.id" v-if="invoice.invoice_file_id"></InvoicePicture>
                                <span v-else>-</span>
                            </td>
                        </tr>
                    </table>
                </div>
                <Spin fix v-if="loading"></Spin>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import InvoiceUtil from '../libs/util';
    import InvoicePicture from './invoice_picture';
    export default {
        components: { InvoicePicture },
        props: {
            model: {
                type: String,
                required: true
            },
            model_id: {
                type: Number,
                required: true
            }
        },
        data(){
            return {
                invoices: [],
                is_empty: false,
                loading: false
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            getInvoiceType(invoice){
                return InvoiceUtil.getInvoiceType(invoice.invoice_type);
            },
            formatPrice(price){
                return Util.formatPrice(price);
            },
            viewInvoices(){
                this.loading = true;
                Util.ajax.get(Util.api.view_model_invoice, {
                    params: {
                        model: this.model,
                        model_id: this.model_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        this.invoices = data.invoices;
                        this.is_empty = (this.invoices.length === 0);
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
